'use client';

import { useIntl } from 'react-intl';
import { CardContent } from '@packages/shared/src/ui/Card/Card';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { joeMessages } from './messages';
import { useJoeConnectionActions } from './JoeConnectionProvider.client';

/**
 * Connected jö Bonus Club status, embedded in the personal customer card.
 *
 * Rendered as a single direct child of the `hasAutoSeparation` card so the separators above and
 * below the section come from the shared card primitive.
 *
 * `Konto trennen` deletes the loyalty connection through the provider actions. While the
 * mutation runs the action reads as unavailable and busy, so it cannot be fired twice.
 */
export const JoeConnectedSection = () => {
  const { formatMessage } = useIntl();
  const {
    company: { name: companyName },
  } = useConfig();
  const { disconnect, isDisconnecting } = useJoeConnectionActions();

  return (
    <CardContent className="flex gap-1.5 pb-2" data-testid="joe-connected-section">
      <span className="icon-emp-joe-logo size-3 flex-none" />
      <div className="flex flex-col items-start">
        <p className="text-size-body-sm">
          {formatMessage(joeMessages.connectedMessage, { companyName })}
        </p>
        <Button
          variant="link"
          aria-disabled={isDisconnecting}
          aria-busy={isDisconnecting}
          onClick={disconnect}
          className="text-size-body-sm min-h-auto"
        >
          {formatMessage(joeMessages.disconnectButton)}
        </Button>
      </div>
    </CardContent>
  );
};
